<template>
  <div class="row">
    <div class="col-xl-12 col-xs-12 vcenter" >
      <div class="form-middle" v-if="!loader">
        <div class="title-form">
            <h1>Hello friend</h1>
            <span class="bigger" v-if="!lookup"> Welcome back, login to access your account. </span>
            <span class="bigger" v-if="lookup">Login first to find your record.</span>
        </div>
        <div>
          <div class="w-form">
            <form id="email-form" @submit.prevent="ligin" name="email-form" data-name="Email Form">
              <flash-message></flash-message>
              <div class="field">
                <input type="email" v-model="form.email" placeholder="name@example.com" class="input-form" required>
                <label for="email">Email address</label>
              </div>
              <div class="field">
                <input type="password" v-model="form.password" placeholder="Password" class="input-form" required>
                <label for="password">Password</label>
              </div>
              <div class="form-medium-content">
                <div class="content-right">
                  <router-link tag="span" class="pointer" to="/user/forgot_password">
                    Forgot password?
                  </router-link>
                </div>
              </div>
              <input type="submit" value="Login" class="btn btn-large">
              </form>
              <ButtonGoogleOauth title="Sign in with Google" />
              <div class="form-down-content">
                Don't have an account? <router-link to="/user/register" class="register-link"> Register here </router-link>
              </div>
          </div>
        </div>
      </div>
      <div v-if="loader">
        <div class="spinner">
            <div class="double-bounce1"></div>
            <div class="double-bounce2"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Vue from 'vue'
import ButtonGoogleOauth from '../components/ButtonGoogleOauth'
import { mapMutations } from 'vuex'

export default {
  name: 'login',
  components: {
    ButtonGoogleOauth
  },
  mounted () {
    this.messageStorage.destroyAll()
    if (this.authenticated && this.user_data.email_verified) {
      this.$router.push({ name: 'upload_leads' })
    }
    if (this.$route.query.new_password === 'true') {
      this.messageStorage.flash('Password changed, please login!', 'success')
    }
    if (this.lookup) {
      this.$router.push({ name: 'login', query: { lookup: this.lookup } })
    }
  },
  data () {
    return {
      form: {
        email: '',
        password: ''
      },
      messageStorage: this.flash()
    }
  },
  methods: {

    ...mapMutations([
      'user/setAuthUser',
      'user/changeLoaderState'
    ]),

    ligin: function () {
      this['user/changeLoaderState'](true)
      this.$http.post('/api/user/login', this.form).then((res) => {
        this.messageStorage.destroyAll()
        this.messageStorage.flash('Welcome ' + res.data.full_name, 'success')
        this['user/setAuthUser'](res.data)
        Vue.http.headers.common['Authorization'] = 'Bearer ' + res.data.access_token
        if (this.lookup) {
          this.$router.push({ name: 'lookup', query: { lookup: this.lookup } })
        } else {
          this.$router.push({ name: 'upload_leads' })
        }
        this['user/changeLoaderState'](false)
        // this.$router.go()
      }).catch((err) => {
        this.messageStorage.destroyAll()
        this.messageStorage.flash(err.data.error, 'error')
        this['user/changeLoaderState'](false)
        // this.form.password = ""
      })
    }
  },
  computed: {
    loader: function () {
      return this.$store.state.user.loader
    },
    lookup: function () {
      return this.$store.state.user.lookup
    },
    authenticated: function () {
      return this.$store.state.user.authenticated
    },
    user_data: function () {
      return this.$store.state.user.data
    }
  }
}

</script>

<style lang="scss">

.pointer{
  cursor: pointer;
}

</style>
